import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { NotificationFeedsComponent } from "./notification-feeds/notification-feeds.component";
import { RequestFeedsComponent } from "./request-feeds/request-feeds.component";
import { RequestorSideComponent } from "./request-feeds/requestor-side/requestor-side.component";

const routes: Routes = [

  { path: '', title: ' Requests',component: RequestFeedsComponent },
  { path: 'notification', title: ' Notfications', component: NotificationFeedsComponent },
  { path: 'requestor', title: ' Requestor',component: RequestorSideComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FeedsRoutingModule { }
